module.exports = {
  metadata: () => {
    return {
      id: "tts",
      name: i18n.t("tts.read-aloud"),
      description: window.toHTML(i18n.t("tts.description")),
      launch: false,
      lab: "graduate",
      learnMore: false,
      toggle: false,
      expanded: false,
      type: "panel"
    };
  }
};
